export default {
    api: {
        endpointBase: "",
        accessToken: ""
    }
}
